/* Keep the Instagram grid ready before it enters view and recover hidden promotions. */
(() => {
  const feeds = new WeakSet();
  const prepareFeed = (root) => {
    if (feeds.has(root)) return;
    feeds.add(root);
    let near = false;
    const load = () => {
      if (!near) return;
      // Instafeed gives its static grid the same swipe-blocking flag as its carousels.
      // A diagonal finger movement then cancels page scrolling despite no sideways row.
      root.querySelectorAll('.instafeed-new-layout-container[data-layout="6"]').forEach((grid) => {
        if (grid.dataset.instafeedPreventTouchScroll !== 'false') grid.dataset.instafeedPreventTouchScroll = 'false';
      });
      root.querySelectorAll('.instafeed-new-layout-item img[data-instafeed-src]').forEach((img) => {
        const src = img.dataset.instafeedSrc;
        if (!src || img.getAttribute('src') === src) return;
        img.loading = 'eager';
        img.decoding = 'async';
        // Preserve the app's handlers and retry behavior. Its observer may still run later.
        img.addEventListener('load', () => img.closest('.instafeed-new-layout-item')?.classList.add('image-loaded'), { once: true });
        img.src = src;
      });
    };
    // The app can render or replace the grid after this script has run.
    new MutationObserver(load).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-instafeed-src', 'data-instafeed-prevent-touch-scroll', 'data-layout'] });
    if (!('IntersectionObserver' in window)) { near = true; load(); return; }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      near = true; observer.disconnect(); load();
    }, { rootMargin: '1200px 0px' });
    observer.observe(root);
  };
  document.querySelectorAll('[id*="instafeed_app_block"]').forEach(prepareFeed);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[id*="instafeed_app_block"]').forEach(prepareFeed);
  });

  if (!matchMedia('(max-width: 749px)').matches) return;
  let checkTimer;
  const roots = new Set();
  const visible = (el) => {
    if (!el || !el.getClientRects().length) return false;
    for (let node = el; node && node !== document.body; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    const box = el.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.right > 0 && box.top < innerHeight && box.left < innerWidth;
  };
  const canTap = (el) => {
    if (!visible(el) || el.closest('[inert]')) return false;
    const box = el.getBoundingClientRect();
    const hit = document.elementFromPoint(box.left + box.width / 2, box.top + box.height / 2);
    return !!hit && el.contains(hit);
  };
  const check = () => {
    if (checkTimer) return;
    // Allow the app to finish its entrance or step transition before checking it.
    checkTimer = setTimeout(() => {
      checkTimer = null;
      roots.forEach((root) => {
        if (!root.isConnected) { roots.delete(root); return; }
        if (root.getAttribute('aria-modal') !== 'true') return;
        const popup = root.querySelector('[id^="alia-popup-root"]');
        const close = root.querySelector('[aria-label="Close popup"]');
        if (visible(root) && visible(popup) && canTap(close)) return;
        // An intentionally opened theme/app dialog can cover the promotion.
        // Keep its lock intact and inspect the promotion again after it closes.
        if ([...document.querySelectorAll('[aria-modal="true"]')].some((dialog) => dialog !== root && !root.contains(dialog) && visible(dialog))) return;
        // Let Alia release its own focus trap and iOS body/html scroll locks.
        // Never clear global overflow here: the cart, menu or search may own it.
        if (typeof window.alia?.close === 'function') window.alia.close();
      });
    }, 2000);
  };
  const discover = () => {
    document.querySelectorAll('[id^="alia-root-"]').forEach((root) => {
      if (roots.has(root)) return;
      roots.add(root);
      new MutationObserver(check).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'aria-modal'] });
      check();
    });
  };
  new MutationObserver(discover).observe(document.body, { childList: true });
  discover();
  window.addEventListener('pageshow', check);
  window.addEventListener('resize', check);
  window.visualViewport?.addEventListener('resize', check);
  document.addEventListener('focusin', check);
  document.addEventListener('pointerup', check, { passive: true });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
})();
